/*doc
---
title: $.loading()
name: loading
category: Javascript - Components
---

// TODO Documentation and example

```html_example

```

```js_example
$(document).on('turbolinks:load', function() {

})
```
*/
(function ($) {
  'use strict'

  $.fn.loading = loading

  function loading(isLoading) {
    isLoading = (isLoading === undefined || isLoading === null) ? true : !!isLoading

    $(this).addClass('is-loading')

    return this
  }

}(jQuery))
